module.exports = __webpack_public_path__ + "c3e3382c50cdc9150344ccedd2b7fa52.svg";